import ChangeEventsOverview from '../components/ChangeEventsOverview.vue';
import ChangeEventList from '../components/ChangeEventList.vue';
import ChangeEventDetail from '../components/ChangeEventDetail.vue';
import ChangeEventSettings from '../components/ChangeEventSettings.vue';
import SiteIncidentList from '../components/SiteIncidentList.vue';
import SiteIncidentDetail from '../components/SiteIncidentDetail.vue';

export default [
  {
    path: '',
    // The section opens on what the customer cares about most.
    redirect: 'site-incidents'
  },
  {
    path: 'overview',
    component: ChangeEventsOverview,
    meta: {
      title: 'Aggregated Alerts Overview',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/change-events',
          title: 'Aggregated Alerts'
        },
        {
          path: '',
          title: 'Overview'
        }
      ]
    }
  },
  {
    path: 'list',
    component: ChangeEventList,
    meta: {
      title: 'Grouped Alerts',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/change-events',
          title: 'Aggregated Alerts'
        },
        {
          path: '',
          title: 'Grouped Alerts'
        }
      ]
    }
  },
  {
    path: 'detail/:id',
    component: ChangeEventDetail,
    meta: {
      title: 'Aggregated Alert Detail',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/change-events',
          title: 'Aggregated Alerts'
        },
        {
          path: '/change-events/list',
          title: 'Grouped Alerts'
        },
        {
          path: '',
          title: 'Aggregated Alert Detail',
          isDisplayId: true
        }
      ]
    }
  },
  {
    path: 'site-incidents',
    component: SiteIncidentList,
    meta: {
      title: 'Site-Wide Incidents',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/change-events',
          title: 'Aggregated Alerts'
        },
        {
          path: '',
          title: 'Site-Wide Incidents'
        }
      ]
    }
  },
  {
    path: 'site-incidents/:id',
    component: SiteIncidentDetail,
    meta: {
      title: 'Site-Wide Incident Detail',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/change-events',
          title: 'Aggregated Alerts'
        },
        {
          path: '/change-events/site-incidents',
          title: 'Site-Wide Incidents'
        },
        {
          path: '',
          title: 'Site-Wide Incident Detail',
          isDisplayId: true
        }
      ]
    }
  },
  {
    path: 'settings',
    component: ChangeEventSettings,
    meta: {
      title: 'Aggregated Alerts Settings',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/change-events',
          title: 'Aggregated Alerts'
        },
        {
          path: '',
          title: 'Settings'
        }
      ]
    }
  }
];
